import { render, staticRenderFns } from "./MaestroDocumentosNewDocumentDialog.vue?vue&type=template&id=7c4263ca&scoped=true&"
import script from "./MaestroDocumentosNewDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./MaestroDocumentosNewDocumentDialog.vue?vue&type=script&lang=js&"
import style0 from "./MaestroDocumentosNewDocumentDialog.vue?vue&type=style&index=0&id=7c4263ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4263ca",
  null
  
)

export default component.exports